import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import he from 'he';
import html2canvas from 'html2canvas';

import { getPartDescription } from 'redux/reducers';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const makeListPDF = (orderSections, getString, partsStrings) => {
  const docDefinition = {
    info: {
      title: 'Dräger HCA Connect Order'
    },
    content: [
      {
        text: getString('monitoring-accessories', 'general').toUpperCase(),
        style: 'title'
      },
      ...orderSections.map(orderSection => ([
        {
          unbreakable: 'true',
          style: 'table',
          table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
            headerRows: 2,
            widths: ['70%', '15%', '*'],

            body: [
              [
                {
                  colSpan: 3,
                  margin: [0, 2],
                  style: 'header',
                  text: getString(orderSection.partsCategory, 'accessories').toUpperCase().replace(/<.+?>/g, '')
                },
                {},
                {}
              ],
              [
                {
                  text: getString('description'),
                  style: 'subheader'
                },
                {
                  text: getString('part-no'),
                  style: 'subheader'
                },
                {
                  alignment: 'center',
                  text: getString('quantity'),
                  style: 'subheader'
                }
              ],
              ...orderSection.orderList.map(orderItem => ([
                { text: he.decode(getPartDescription(orderItem.part.partNo, partsStrings)), style: 'cell' },
                orderItem.part.partNo,
                { text: orderItem.quantity.toString(), alignment: 'center' }
              ]))
            ]
          },
          layout: 'lightHorizontalLines'
        }
      ]))],
    styles: {
      title: {
        fontSize: 14,
        margin: [0, 4],
        color: '#6b7074'
      },
      header: {
        fontSize: 12,
        bold: true,
        color: '#010199'
      },
      subheader: {
        fontSize: 10,
        bold: true
      },
      table: {
        margin: [0, 5, 0, 20]
      },
      cell: {
        fontSize: 10,
        margin: [0, 3]
      },
      quote: {
        italics: true
      },
      small: {
        fontSize: 8
      }
    }
  };
  // pdfMake.createPdf(docDefinition).download('optionalName.pdf');
  return pdfMake.createPdf(docDefinition);
};


const encodePartImage = async (node) => {
  try {
    const imageId = node.id;
    const canvas = await html2canvas(node, { useCORS: true });
    return {
      imageId,
      base64: canvas.toDataURL('image/jpeg'),
    };
  } catch (e) {
    console.error(e);
  }
  return '';
};

const columnWidth = 160;
const makeImageTableColumns = next3 => next3.map( orderItem => ({
  image: orderItem.part.imageId,
  width: columnWidth,
}));

const makeDescriptionColumns = (next3, partsStrings) => next3.map(orderItem => ({
  width: columnWidth,
  layout: 'noBorders',
  style: 'imageLayoutTable',
  table: {
    widths: ['75%', '25%'],
    body: [
      [
        {
          style: 'imageLayoutHeader',
          text: 'Description'
        },
        {
          style: 'imageLayoutHeader',
          text: 'Qty',
          alignment: 'right'
        }
      ],
      [
        {
          text: he.decode(getPartDescription(orderItem.part.partNo, partsStrings))
        },
        {
          text: orderItem.quantity.toString(),
          alignment: 'right'
        }
      ]
    ]
  }
}));

export const makeImagePDF = (orderSections, getString, partsStrings) => {
  const orderListRows = (orderSection) => {
    // each row contains 3 items
    const orderList = orderSection.orderList;
    const next3 = orderList.slice(0, 3);

    // first element is the order section header, and first row of images to avoid page breaking
    const elements = [
      {
        style: 'imageLayoutSectionHeader',
        unbreakable: 'true',
        layout: 'headerLineOnly',
        table: {
          headerRows: 1,
          widths: ['100%'],
          body: [
            [{
              text: getString(orderSection.partsCategory, 'accessories').toUpperCase().replace(/<.+?>/g, '')
            }],
            [{
              marginTop: 4,
              columns: makeImageTableColumns(next3),
            }],
            [{
              columns: makeDescriptionColumns(next3, partsStrings),
            }]
          ]
        }
      }
    ];

    let idx = 3;
    //`${partImagesRoot}/${orderItem.part.imageId}.jpg`
    while (orderList.length > idx) {
      const next3 = orderList.slice(idx, idx + 3);
      const imageColumns = {
        columns: makeImageTableColumns(next3),
      };
      const descriptionColumns = {
        columns: makeDescriptionColumns(next3, partsStrings),
      };
      idx += 3;

      // add image column and desciption column elements
      elements.push(imageColumns, descriptionColumns);
    }

    return elements;
  };

  return new Promise(async (resolve, reject) => {

    // get all elements with class 'image-container' on the page
    const imageContainers = Array.from(document.getElementsByClassName('image-container'));

    // create a hash key'ed by the imageId for each part
    const partImages = await Promise.all(imageContainers.map(encodePartImage));
    const docDefinition = {
      info: {
        title: 'Dräger HCA Connect Order'
      },
      content: [
        {
          text: getString('monitoring-accessories', 'general').toUpperCase(),
          style: 'title',
        },
        ...orderSections.map(orderListRows),
      ],
      images: {
        ...partImages.reduce((acc, img) => ({
          ...acc,
          [img.imageId]: img.base64,
        }), {}),
      },
      styles: {
        title: {
          fontSize: 14,
          margin: [0, 4],
          color: '#6b7074'
        },
        header: {
          fontSize: 12,
          bold: true,
          color: '#010199'
        },
        subheader: {
          fontSize: 10,
          bold: true
        },
        table: {
          margin: [0, 5, 0, 20]
        },
        cell: {
          fontSize: 10,
          margin: [0, 3]
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        imageLayoutSectionHeader: {
          fontSize: 12,
          bold: true,
          color: '#010199',
          margin: [0, 0, 0, 3]
        },
        imageLayoutHeader: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 4]
        },
        imageLayoutTable: {
          margin: [0, 5, 0, 20],
          color: '#000'
        },
      },
      defaultStyle: {
        columnGap: 20
      }
    };

    resolve(pdfMake.createPdf(docDefinition));
  });

  // pdfMake.createPdf(docDefinition).download('optionalName.pdf');
};

/* jsPDF; Almost worked but can't handle some unicode characters.

const PART_DESCRIP_X = 21;
const PART_NO_X = 153;
const PART_QUANTITY_X = 180;

export default (orderSections, partsStrings, accessoriesStrings) => {
  // create the document
  const doc = new jsPDF();

  // font
  doc.setFont('Helvetica');

  // go through each section
  let py = 30;
  orderSections.forEach((orderSection) => {
    // setup font for header
    doc.setFontSize(13);
    doc.setFontType('bold');
    doc.setTextColor('#010199');
    doc.text(20, py, accessoriesStrings[orderSection.partsCategory].toUpperCase().replace(/<.+?>/g, ''));

    // underline
    doc.setDrawColor('#aaaaaa');
    doc.line(20, py + 2, 200, py + 2);

    // heading
    py += 10;
    doc.setFontSize(11);
    doc.setTextColor(0);
    doc.text(PART_DESCRIP_X, py, 'Description');
    doc.text(PART_NO_X, py, 'Part No.');
    doc.text(PART_QUANTITY_X, py, 'Quantity');

    // underline
    doc.setDrawColor(0);
    doc.line(21, py + 2, 200, py + 2);

    // parts
    py += 8;

    doc.setFontSize(10);
    doc.setFontType('normal');
    orderSection.orderList.forEach((partOrder) => {
      // description, part #, quantity
      const description = he.decode(getPartDescription(partOrder.part.partNo, partsStrings));
      const splitStrings = doc.splitTextToSize(description, 125);
      console.log(splitStrings);

      doc.text(PART_DESCRIP_X, py, splitStrings[0] + (splitStrings.length > 1 ? '...' : ''));
      doc.text(PART_NO_X, py, partOrder.part.partNo);
      doc.text(PART_QUANTITY_X + 7, py, partOrder.quantity.toString());

      // underline
      doc.setDrawColor('#dadada');
      doc.line(21, py + 2, 200, py + 2);

      py += 8;
    });

    py += 10;
  });
  window.open(doc.output('bloburl'), '_blank');
  //doc.save('test.pdf');
};
*/
